// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__-1M32","calendarButtons":"ClockData_calendarButtons__pZNy3"};